export default __webpack_public_path__ + "static/media/_header.674b285d.jpeg";